import { UserModel } from "../../user/_models/user.model";

export class FolderModel {
  id: number;
  name: string;
  description: string;
  expiration_date: string;
  guide_file: any;
  active: string;
  functionary: any;
  room: any;
}
